module.exports = __webpack_public_path__ + "fonts/b20ff45.ttf";